import { createSelector } from '@ngrx/store';

import { ValidationResponse } from '@models/swagger';
import { State } from './reducer';
import { selectValidateFiscalCodeState } from '../selectors';

export const getData = createSelector(selectValidateFiscalCodeState, (state: State) => state.data);

export const getError = createSelector(selectValidateFiscalCodeState, (state: State) => state.error);

export const getLoading = createSelector(selectValidateFiscalCodeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ValidationResponse) => T) =>
  createSelector(selectValidateFiscalCodeState, (state: State) => fn(state.data));
